
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 440 440","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M165.919 113.697h108.093V93.181c0-.833-.29-1.649-.786-2.226l-.347-.289c-.543-.545-1.36-.856-2.239-.856H169.36c-.961 0-1.832.341-2.39.936-.67.672-1.051 1.583-1.051 2.435v20.516zm33.186 197.74h41.79V265.38a6.413 6.413 0 016.404-6.405h46.061v-41.79H247.3a6.413 6.413 0 01-6.405-6.405V164.72h-41.79v46.059a6.413 6.413 0 01-6.405 6.406h-46.06v41.79h46.06a6.412 6.412 0 016.405 6.404v46.059zm48.194 12.742H192.7c-3.53 0-6.404-2.842-6.404-6.337v-46.058h-46.06a6.413 6.413 0 01-6.405-6.405v-54.6c0-3.569 2.874-6.474 6.405-6.474h46.06v-46.06c0-3.492 2.873-6.335 6.404-6.335h54.6c3.531 0 6.404 2.843 6.404 6.336v46.06h46.06c3.532 0 6.405 2.904 6.405 6.473v54.6a6.413 6.413 0 01-6.405 6.405h-46.06v46.058c0 3.495-2.873 6.337-6.405 6.337zM58.028 126.507a13.09 13.09 0 00-9.311 3.935c-2.572 2.51-3.907 5.729-3.907 9.352v196.57c0 3.562 1.343 6.79 3.886 9.332 2.47 2.47 5.871 3.886 9.332 3.886h323.876c3.494 0 6.84-1.388 9.421-3.908 2.478-2.538 3.866-5.86 3.866-9.31v-196.57c0-3.51-1.38-6.825-3.886-9.332-2.552-2.55-5.89-3.955-9.401-3.955H58.028zm323.876 235.885H58.028c-6.967 0-13.508-2.703-18.415-7.612C34.703 349.872 32 343.33 32 336.364v-196.57c0-6.967 2.703-13.508 7.613-18.416l.726-.726h.086c4.79-4.493 11-6.955 17.603-6.955h95.082V93.181c0-4.218 1.692-8.28 4.766-11.438C160.941 78.676 165.012 77 169.36 77h101.28c4.2 0 8.087 1.528 10.977 4.308.243.17.401.328.485.412 3.096 3.182 4.79 7.244 4.79 11.461v20.516h95.012c6.922 0 13.462 2.728 18.416 7.681 4.876 4.796 7.68 11.514 7.68 18.416v196.57c0 6.923-2.728 13.464-7.68 18.416-4.91 4.909-11.45 7.612-18.416 7.612z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    